import { useTheme } from '@emotion/react';
import { Label } from '@presentation/components';
import type { FC } from 'react';
import * as Styled from './styled';
import type { StepCardProps } from './types';

export const StepCard: FC<StepCardProps> = (props) => {
  const { img, label, title, text, bubble } = props;
  const theme = useTheme();

  return (
    <Styled.Wrapper>
      <Label
        content={label}
        size="large"
        textColor={theme.color.purple.default}
        bgColor={theme.color.purple.tint}
      />

      <Styled.ImageWrapper>
        <img src={img} alt="registration" width="100%" />
      </Styled.ImageWrapper>

      <Styled.Title>{title}</Styled.Title>
      <Styled.Text>{text}</Styled.Text>
      {bubble && (
        <Styled.Bubble>
          <img src={bubble} alt="" width="225" />
        </Styled.Bubble>
      )}
    </Styled.Wrapper>
  );
};
